import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ExportPackageIcon extends BaseIcon {

  getChildren = () => {
    const color = this.getColor() === 'currentColor' ? '#2e3f58' : this.getColor()
    return [
      <path d="m11 3 5 3.4-5 3.6V8s-.7-.1-2.4.1C5.8 8.4 4 10 4 10s1.3-3.7 4.6-4.4C11.3 5 11 5 11 5V3zM4.5 7C3.1 7 2 8.1 2 9.5S3.1 12 4.5 12 7 10.9 7 9.5l2-.3v.3C9 12 7 14 4.5 14S0 12 0 9.5 2 5 4.5 5H5l-.5 2c.1 0 0 0 0 0z" fillRule="evenodd" clipRule="evenodd" fill={color}/>
    ]
  }
  getViewBox = () => '0 0 16 16'
}
